import { render, staticRenderFns } from "./updateSN.vue?vue&type=template&id=2654779a"
import script from "./updateSN.vue?vue&type=script&lang=js"
export * from "./updateSN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports